export default {
  endpoint: '',
  customer: JSON.parse($('meta[name="x-customer"]').attr('content')),
  url: (path) => {
    return path;
  },
};
